import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {VisualBox} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/VisualBox';
import {DnDHoveredDropTargetHighlightType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/dnd/DnDHoveredDropTargetHighlightType';
import {DnDModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/dnd/DnDModel';
import {Repeater} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/Repeater';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {CSSProperties} from 'react';

const styles = require('./DnDMask.less');

export interface IDnDMaskProps
{
    visualBox:VisualBox;
    repeater:Repeater;
    boxUniqueId:GUID;
}

@observer
export class DnDMask extends React.Component<IDnDMaskProps, any>
{
    @computed
    private get _isHoveredTarget():boolean
    {
        const {boxUniqueId} = this.props;
        const {area: {surfaceDnDState: {dropTargetBoxUniqueId}}} = rootState.ui.visualDesigner.surfaceEditor;

        return boxUniqueId === dropTargetBoxUniqueId;
    }

    private get _dropTargetBorderStyle():CSSProperties
    {
        const {visualBox: {repeatedData}, repeater} = this.props;

        if( this._isHoveredTarget )
            return null;

        const dnd:DnDModel = repeatedData.get(repeater.index).dnd;

        let targetStyle:CSSProperties = null;

        if( dnd.isCustomPreviewStyle && dnd.isCustomPreviewStyle.value )
            targetStyle = {
                ...dnd.targetBackground.toCss(),
                ...dnd.targetBorder.toCSS()
            };

        return targetStyle;
    }

    private get _hoveredDropTargetBorderStyle():CSSProperties
    {
        const {visualBox: {repeatedData}, repeater} = this.props;

        if( !this._isHoveredTarget )
            return null;

        const {surfaceDnD} = commonControllers;
        const dnd:DnDModel = repeatedData.get(repeater.index).dnd;
        const borderStyle:CSSProperties = dnd.hoveredTargetBorder.toCSS();

        let targetStyle:CSSProperties = null;

        if( !DnDHoveredDropTargetHighlightType.isNone(dnd.hoveredDropTargetHighlightType) )
        {
            if( dnd.isCustomPreviewStyle && dnd.isCustomPreviewStyle.value )
                targetStyle = {
                    visibility: 'visible',
                    ...dnd.hoveredTargetBackground.toCss(),
                    ...surfaceDnD.getDropTargetDividerStyle(borderStyle.border)
                };
            else
                targetStyle = {
                    visibility: 'visible',
                    ...surfaceDnD.getDropTargetDividerStyle()
                };
        }

        return targetStyle;
    }

    public render():JSX.Element
    {
        return <div
            data-box-dnd-mask="true"
            className={styles.boxDnDMask}
        >
            <div data-box-dnd-mask-target="true" style={this._dropTargetBorderStyle} />
            <div data-box-dnd-mask-hovered-target="true" style={this._hoveredDropTargetBorderStyle} />
        </div>;
    }
}
